import { render } from "./CuidadosView.vue?vue&type=template&id=17c2b09c&scoped=true"
import script from "./CuidadosView.vue?vue&type=script&lang=js"
export * from "./CuidadosView.vue?vue&type=script&lang=js"

import "./CuidadosView.vue?vue&type=style&index=0&id=17c2b09c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c2b09c"]])

export default __exports__